<template>
  <div
    class="d-flex align-center justify-center flex-column"
    style="height: 80vh"
  >
    <div>
      <v-icon size="48">
        mdi-wifi-off
      </v-icon>
    </div>
    <div class="text-h4 mt-6">
      {{ $t('CheckThatYouLogin') }}
    </div>
    <div class="text-body-1 mt-2 text--secondary">
      {{ $t('LoginRequiredForUsingAaden') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfflineModePage'
}
</script>

<style scoped>

</style>
